// 차트 데이터 라벨(chartjs-plugin-datalabels) 공용 유틸
// 저장 옵션(JSON) ↔ Chart.js plugin 옵션(함수 포함) 변환 책임을 담당한다.

export const datalabel_format_options = [
  { value: 'raw', text: '원본값' },
  { value: 'thousands', text: '천 단위 콤마' },
  { value: 'percent', text: '백분율(%)' }
];

export const datalabel_anchor_options = [
  { value: 'end', text: '바깥쪽(end)' },
  { value: 'center', text: '가운데(center)' },
  { value: 'start', text: '안쪽(start)' }
];

export const datalabel_align_options = [
  { value: 'top', text: '위' },
  { value: 'bottom', text: '아래' },
  { value: 'start', text: '시작' },
  { value: 'center', text: '가운데' },
  { value: 'end', text: '끝' }
];

export const DEFAULT_DATALABELS_OPTIONS = Object.freeze({
  display: false,
  formatter: 'raw',
  anchor: 'end',
  align: 'top',
  fontSize: 11,
  color: '#333333'
});

const ROUND_CHARTS = ['pie', 'doughnut', 'polarArea', 'radar'];

function buildFormatter(formatterType) {
  return function (value, ctx) {
    const raw = typeof value === 'object' && value !== null ? value.y ?? value.r ?? value : value;
    const num = Number(raw);
    if (!Number.isFinite(num)) return raw == null ? '' : String(raw);

    if (formatterType === 'percent') {
      const dataset = ctx?.chart?.data?.datasets?.[ctx.datasetIndex]?.data || [];
      const total = dataset.reduce((acc, v) => {
        const item = typeof v === 'object' && v !== null ? v.y ?? v.r ?? v : v;
        const n = Number(item);
        return Number.isFinite(n) ? acc + n : acc;
      }, 0);
      if (!total) return '0%';
      return `${((num / total) * 100).toFixed(1)}%`;
    }

    if (formatterType === 'thousands') {
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    // 'raw' 및 그 외: 원본 문자열 그대로 반환
    return String(raw);
  };
}

// 차트 타입에 맞춘 anchor/align 기본값 보정
function pickAnchorAlign(savedOptions, chartType) {
  const isRound = ROUND_CHARTS.includes(chartType);
  const anchor = savedOptions.anchor || (isRound ? 'center' : DEFAULT_DATALABELS_OPTIONS.anchor);
  const align = savedOptions.align || (isRound ? 'center' : DEFAULT_DATALABELS_OPTIONS.align);
  return { anchor, align };
}

// 저장된 옵션을 Chart.js plugin 옵션 형태로 변환(formatter 함수 매핑 포함)
export function resolveDatalabelsOptions(savedOptions, chartType) {
  const cfg = { ...DEFAULT_DATALABELS_OPTIONS, ...(savedOptions || {}) };
  if (!cfg.display) return { display: false };

  const { anchor, align } = pickAnchorAlign(cfg, chartType);

  return {
    display: true,
    anchor,
    align,
    color: cfg.color || DEFAULT_DATALABELS_OPTIONS.color,
    font: {
      size: Number(cfg.fontSize) || DEFAULT_DATALABELS_OPTIONS.fontSize
    },
    formatter: buildFormatter(cfg.formatter || 'raw')
  };
}

// 첫 번째 dataset의 type을 차트 타입으로 추정(혼합 차트 대응)
export function inferChartType(chartConfig) {
  const datasets = chartConfig?.data?.datasets;
  if (Array.isArray(datasets) && datasets.length) {
    return datasets[0].type || chartConfig?.type || 'bar';
  }
  return chartConfig?.type || 'bar';
}
